import React from 'react'
import { LayoutGrid } from 'lucide-react'

// Icono del menú lateral: blanco translúcido sobre el color del cliente, como los de assets/drawerIcons.
// No usa las props que manda el drawer (htmlColor, fontSize): son de SvgIcon y acabarían en el <svg>.
const icon = () => (
  <LayoutGrid size={20} color="white" opacity={0.6} />
)

export default icon
